import { Injectable } from '@angular/core';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContextFactory } from '@shared/factories/context/context.factory';

@Injectable({
  providedIn: 'root'
})

export class productInfoResolve  {
  constructor(private apiService: ApiServiceService,
    private context: ContextFactory
  ) { }
  resolve(route: ActivatedRouteSnapshot,) {
    let productId: any = this.context.settings.defaultProduct;
    return this.apiService.get('products/', productId)
      .then((data:any)=>{
        // data = {
        //   productId,
        //   name,
        //   externalId
        // }
        return data;
    })
  }
}
